export default function isUndefinedValue(value) {
  return value === undefined || value === null || typeof value === 'string' && value.match(/(undefined|null)/) !== null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela-utils/es/isUndefinedValue.js
// module id = 717
// module chunks = 0